import * as React from "react"
import { useState, useEffect } from "react"
import Styled from 'styled-components'
import { Tab } from "react-bootstrap"
import * as toastr from "toastr"

import getConfig from "Placements/Utils/GetRequestConfig.util"

import TabStyle from "Placements/Styles/Tab.style"
import Table from "Placements/Components/Table";
import CONFIG_TABLE_REPORT from "Placements/Configs/Tables/ReportNote.config";
import CONFIG_TABLE_RESPONSE from "Placements/Configs/Tables/ReportResponse.config";
import API from "Placements/API"

const Header = Styled.h1`
   color: ${(props) => props.theme.main.mainPurple};
   padding: 1.5rem 0 0;

   span{
      float: right;
      display: inline-flex;
      -webkit-box-align: center;
      align-items: center;
   }
`

const TestReports = (props: any) => {

   const [respostas, setRespostas] = useState(null)
   const [score, setScore] = useState(null)
   const [messagePageTitle, setMessagePageTitle] = useState(null)
   const { idTesteUser } = props

   useEffect(() => {
      localStorage.setItem("idTesteUser", idTesteUser);
      API.Admin.respostas({ idTesteUser }, getConfig())
         .then((response: any) => setRespostas(response.data))
         .catch((error: any) => {
            toastr.error('Não foi possível recuperar informações', '')
         })
   }, [])

   useEffect(async () => {
      if (respostas) {
         const map = new Map()
         respostas.forEach((element: any) => {
            map.set(element.Id_Teste_Parte, element.NomeParte)
         })

         const array = new Map()
         let lastFinishedTest = null;

         for (var [key, value] of map.entries()) {
            const resp = await API.TesteParte.GetScoreCategory({ idTesteParte: key }, getConfig())
               .then((response: any) => response.data)
               .catch((error: any) => {
                  toastr.error('Não foi possível recuperar informações', '')
               })

            if (resp != null && resp.length != 0) {
               if (messagePageTitle == null) {
                  setMessagePageTitle(value)
                  lastFinishedTest = resp;
               }

               array.set(value, resp)
            }

         }

         props.getLastScore(lastFinishedTest)
         setScore(array)
      }
   }, [respostas])

   const tabs = () => {
      let tabs = []

      if (score) {
         for (var key of score.keys()) {
            tabs.push(<Tab key={key} eventKey={key} title={key} className="px-4" />)
         }

         return <TabStyle
            defaultActiveKey={messagePageTitle}
            onSelect={(k: string) => setMessagePageTitle(k)}>
            {tabs}
         </TabStyle >
      }

      return null
   }

   const getNotas = () => {
      if (score && messagePageTitle) {
         const array = score.get(messagePageTitle)
         return array
      }
   }

   const getAnswers = () => {
      if (respostas && messagePageTitle) {
         const resps = respostas.filter((element: any) => element.NomeParte == messagePageTitle)
         return resps
      }
   }

   const getLinks = () => {
      if (respostas && messagePageTitle) {
         const links = respostas.filter((element: any) => element.NomeParte == messagePageTitle)
            .map((element: any) => `#/admin/exercise-answered/${element.Id_Teste_Parte}/${element.Id_Exercicio}`)
         return links
      }
   }

   const goToExercice = () => {
      const find = respostas.find((element: any) => element.NomeParte == messagePageTitle)
      window.location.href = `#/admin/exercise-answered/${find.Id_Teste_Parte}`
   }

   return <div>
      {tabs()}
      <Header>Notas</Header>
      <Table className="table-striped" data={getNotas()} config={CONFIG_TABLE_REPORT} />
      <Header>Respostas <span onClick={() => goToExercice()} style={{ cursor: "pointer" }}><em className="material-icons">list_alt</em>Ver {messagePageTitle} completo </span></Header>
      <Table className="table-striped" data={getAnswers()} links={getLinks()} config={CONFIG_TABLE_RESPONSE} />
   </div>
}

export default TestReports